// extracted by mini-css-extract-plugin
export default {"pageWrap":"Ga-z","fullWidth":"Ha-z","heading":"Ia-z","fullBleed":"Ja-z","hidden":"Ka-z"};